import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore';
import { firestore, functions } from '../config/firebase';
import { getFinancedDeal } from './financedDealsService';
import { httpsCallable } from 'firebase/functions';

const COLLECTION = 'interestPaymentEvents';
const recomputeInterestPaymentsCallable = httpsCallable(functions, 'recomputeInterestPaymentsAfterRefund');

/**
 * Fetch trace events for a deal and periodStart (YYYY-MM-01).
 * @param {string} dealId
 * @param {string} periodStart
 * @returns {Promise<Array<object>>}
 */
export async function getInterestPaymentEventsForPeriod(dealId, periodStart) {
  if (!dealId || !periodStart) return [];
  const q = query(
    collection(firestore, COLLECTION),
    where('dealId', '==', dealId),
    where('periodStart', '==', periodStart),
    orderBy('occurredAt', 'asc')
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

/**
 * Record a refund issued for an overpaid period. Lender only.
 * @param {string} dealId
 * @param {string} lenderUid
 * @param {string} periodKey
 * @param {string} periodStart
 * @param {{ amount: number, occurredAt: Date, note?: string }} data
 */
export async function createRefundIssuedEvent(dealId, lenderUid, periodKey, periodStart, data) {
  if (!dealId || !lenderUid || !periodKey || !periodStart) throw new Error('dealId, lenderUid, periodKey, periodStart required');
  const amount = Number(data?.amount);
  if (!Number.isFinite(amount) || amount <= 0) throw new Error('amount must be > 0');
  const occurredAt = data?.occurredAt instanceof Date ? data.occurredAt : new Date();
  const deal = await getFinancedDeal(dealId);
  await addDoc(collection(firestore, COLLECTION), {
    dealId,
    lenderUid,
    ownerUid: deal?.ownerUid || null,
    periodKey,
    periodStart,
    type: 'refund_issued',
    amount,
    occurredAt,
    source: 'manual',
    resendEmailId: null,
    note: data?.note || null,
    createdAt: serverTimestamp(),
  });

  // After recording the refund, recompute interestPayments credits/statuses forward.
  await recomputeInterestPaymentsCallable({
    dealId,
    periodStart,
  });
}

